import { getOverviewBatchTimeline } from '@/pages/opinion/services';
import {
  arrayToSimpleObj,
  sortTimeListFunc,
  supplementSingleData,
} from '@/pages/opinion/utils';
import { formatDateFunc } from '@/pages/opinion/utils/time';
import React, { useEffect, useState } from 'react';
import { Row } from 'tea-component';
import TopMentionsSentiment from './TopMentionsSentiment';
import BottomAccountEngagement from './BottomAccountEngagement';

export default function MentionsSentiment({ xAxisList, commonParams }: any) {
  const [barDataMap, setBarDataMap] = useState({});
  const [lineDataMap, setLineDataMap] = useState({});

  const [loading, setLoading] = useState(false);

  const getTimeLineData = () => {
    setLoading(true);
    let metrics = [
      'mentions',
      'avg_sentiment',
      'account_posts',
      'engagement',
      'non_negative_ratio',
    ];
    // 'mentions', 'avg_sentiment' 这两个指标不需要柱状图数据
    getOverviewBatchTimeline({
      ...commonParams,
      types: ['total', 'slice'],
      metrics: [
        'mentions',
        'avg_sentiment',
        'account_posts',
        'engagement',
        'sentiment',
      ],
      ret_metrics: metrics,
    }).then((res: any) => {
      const formatTimeFunc = formatDateFunc(commonParams.date_type);
      let barMap: any = {};
      let lineMap: any = {};
      let data = res || [];
      data.forEach((item: any) => {
        let { game, value } = item || {};
        let { list, timeline_of_start_time, timeline_of_end_time, total_list } =
          value;
        const metricsMap = arrayToSimpleObj(total_list, 'value', 'key');
        let lineDefault = metrics.map((key) => ({
          name: key,
          key,
          value: 0,
          count: 0,
          time: timeline_of_start_time,
        }));
        const gameDetail = xAxisList?.find(
          (v: any) => game.edition_unified_id === v.edition_unified_id,
        );

        const lineDataMap: any = {};
        (list || lineDefault).forEach((item: any) => {
          let key = item.key;
          if (!lineDataMap[key]) {
            lineDataMap[key] = [];
          }
          lineDataMap[key].push(item);
        });

        metrics.forEach((key) => {
          // 柱状图数据处理
          if (!barMap[key]) {
            barMap[key] = [];
          }
          barMap[key].push({
            ...game,
            value: metricsMap[key],
            name: gameDetail?.entity_name,
            cover: gameDetail?.cover,
          });

          // 折线图数据处理
          if (!lineMap[key]) {
            lineMap[key] = [];
          }

          let realList = supplementSingleData(
            timeline_of_start_time,
            timeline_of_end_time,
            lineDataMap[key],
            commonParams.date_type,
          );

          lineMap[key] = [
            ...lineMap[key],
            ...realList.map((item) => ({
              ...item,
              ...game,
              value: item.count || item.value || 0,
              name: gameDetail?.entity_name,
              cover: gameDetail?.cover,
              time: formatTimeFunc(item.time),
            })),
          ];
        });
      });

      for (const key in lineMap) {
        lineMap[key].sort(sortTimeListFunc('time'));
      }

      for (const key in barMap) {
        const sortList =
          xAxisList?.map((item: any) => item?.edition_unified_id) || [];

        barMap[key] = barMap[key]?.sort(
          (a: any, b: any) =>
            sortList.indexOf(a?.edition_unified_id) -
            sortList.indexOf(b?.edition_unified_id),
        );
      }
      setBarDataMap(barMap);
      setLineDataMap(lineMap);
      setLoading(false);
    });
  };

  useEffect(() => {
    let { edition_unified_id } = commonParams || {};
    if (edition_unified_id) {
      getTimeLineData();
    }
  }, [commonParams]);

  return (
    <Row className="trends-data">
      <TopMentionsSentiment
        barDataMap={barDataMap}
        lineDataMap={lineDataMap}
        loading={loading}
        commonParams={commonParams}
        xAxisList={xAxisList}
      ></TopMentionsSentiment>

      <BottomAccountEngagement
        barDataMap={barDataMap}
        lineDataMap={lineDataMap}
        loading={loading}
        commonParams={commonParams}
        xAxisList={xAxisList}
      ></BottomAccountEngagement>
    </Row>
  );
}
